import React from "react";

export function SchoolProfileWizardNav() {
  return (
    <div className="wizard-nav">
      <div className="wizard-steps">
        <button
          type="button"
          className="wizard-step"
          data-wizard-type="step"
          style={{borderStyle: "none"}}
        >
          <div className="wizard-wrapper">
            <div className="wizard-number">1</div>
            <div className="wizard-label">
              <div className="wizard-title">Okul Bilgileri</div>
            </div>
          </div>
        </button>
        <button
          type="button"
          className="wizard-step"
          data-wizard-type="step"
          style={{borderStyle: "none"}}
        >
          <div className="wizard-wrapper">
            <div className="wizard-number">2</div>
            <div className="wizard-label">
              <div className="wizard-title">Evrak Bilgileri</div>
            </div>
          </div>
        </button>
        <button
          type="button"
          className="wizard-step"
          data-wizard-type="step"
          style={{borderStyle: "none"}}
        >
          <div className="wizard-wrapper">
            <div className="wizard-number">3</div>
              <div className="wizard-label">
                <div className="wizard-title">Mail ve SMS Hesabı</div>
              </div>
          </div>
        </button>
        <button
          type="button"
          className="wizard-step"
          data-wizard-type="step"
          style={{borderStyle: "none"}}
        >
          <div className="wizard-wrapper">
            <div className="wizard-number">4</div>
            <div className="wizard-label">
              <div className="wizard-title">Günlük Ders Saatleri</div>
            </div>
          </div>
        </button>
      </div>
    </div>          
  );
}